module.exports = __webpack_public_path__ + "img/355.87856ba8.jpg";